module.exports = __webpack_public_path__ + "static/img/footer_empower.ae62d07.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/footer_empower.png
// module id = wBfs
// module chunks = 1